<template>
    <!-- One role sheet seat's content: accountabilities as numbered tiles, then each filled section.
         Used by RoleSheetView, TeamHubRoleCol (My Role / View Role) and SignOffCells (a signed seat). -->
    <section v-if="accs.length" :id="prefix + '-acc'" class="rv-sec">
        <h3 class="rv-h">Accountabilities ({{ accs.length }})</h3>
        <ol class="rv-tiles">
            <li v-for="(a, i) in accs" :key="i" class="rv-tile">
                <span class="rv-tn">{{ i + 1 }}</span>
                <div><div class="rv-tt">{{ a.value }}</div><div v-if="a.value2" class="rv-td">{{ a.value2 }}</div></div>
            </li>
        </ol>
    </section>
    <section v-for="(section, i) in shown" :key="section.id || i" :id="prefix + '-' + (section.id || i)" class="rv-sec">
        <h3 class="rv-h">{{ section.label }}</h3>
        <ol v-if="section.tiles" class="rv-tiles">
            <li v-for="(t, k) in section.tiles" :key="k" class="rv-tile">
                <span class="rv-tn">{{ k + 1 }}</span>
                <div><div class="rv-tt">{{ t.title }}</div><div v-if="t.desc" class="rv-td">{{ t.desc }}</div></div>
            </li>
        </ol>
        <div v-else :class="[ /purpose/i.test(section.label || '') ? 'rv-purpose' : 'rv-card', 'rv-rich ve-body' ]" v-html="section.html"></div>
    </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { plainText, seatAccountabilities } from '@/roleSheet';

// Accountability-style text sections show as numbered tiles when they're a list
function tilesFrom(html: string): any[] | null {
    const box = document.createElement('div');
    box.innerHTML = html;
    const items = [...box.querySelectorAll('li')];
    if(!items.length) return null;
    return items.map(li => {
        const bold = li.querySelector('b, strong');
        if(bold && li.innerHTML.trim().startsWith(bold.outerHTML)) {
            return { title: bold.textContent || '', desc: (li.textContent || '').slice((bold.textContent || '').length).replace(/^\s*[—–:-]\s*/, '').trim() };
        }
        return { title: (li.textContent || '').trim(), desc: '' };
    });
}

export default defineComponent({
    name: 'RoleSeat',
    // accountabilities: [{ value, value2 }]. sections: [{ id?, label, html }] in order (empty ones are skipped).
    // prefix: element id prefix, for jumping to a section
    props: {
        accountabilities: { type: Array, default: () => [] },
        sections: { type: Array, default: () => [] },
        prefix: { type: String, default: 'rv' }
    },
    computed: {
        accs(): any[] {
            return seatAccountabilities({ accountabilities: this.accountabilities });
        },
        shown(): any[] {
            return (this.sections as any[])
                .filter(s => plainText(s.html))
                .map(s => ({ ...s, tiles: /accountabilit/i.test(s.label || '') ? tilesFrom(s.html) : null }));
        }
    }
});
</script>
